import { HttpContextToken } from '@angular/common/http';

/** The caller owns recovery; attach credentials but do not replay or redirect on 401. */
export const LOCAL_AUTH_FAILURE = new HttpContextToken<boolean>(() => false);
